class ProfileDetailsRespone {
    constructor({ created_ForId = 0, created_For = "", userid = "", first_Name = "", age = 0, height = 0,userNum=0,
        date_Of_Birth = "",
        casteId = 0, caste = "", sub_Caste = "", gothram = "", mother_TongueId = 0,
        mother_Tongue = "", religionId = 0,
        religion = "",
        marital_StatusId = 0,
        marital_Status = "", family_StatusId = 0,
        family_Status = "",
        disability_id = "",
        disability = "",
        family_TypeId, family_Type, eating_HabitId, eating_Habit, employed_InId, employed_In,
        father_OccupationId, father_Occupation, mother_OccupationId, mother_Occupation,
        education_CategoryId = 0, education_Category = "", occupationId = 0, occupation = "", fromIncome_id = "",
        from_Income = 0, profileImage = "", no_Of_Brothers = "", no_Of_Sister = "", brothers_Married = "", brothersMarried = "", siters_Married = "", body_Type_id, body_Type = "", weight = "", drinking_HabitId, drinking_Habit, smoking_HabitId, smoking_Habit,
        place_of_Birth = "", time_of_birth = "", lives_In = "", family_Values_Id, family_Values, education_in_Detail = "", institution = "", countryId, country, stateCode, state_Id, state, district_Id, district, city = "", citizenship = "",
        horoscope = "", mobile_Number = "", star = "", raasi = "", ancestral_Origin = "", is_Shortlist = "", email_Status = "", mobileNumber_Status = "", documentStatus = "", is_Interestlist = "", type = "", line_1 = "", line_2 = "", 
        isBlocked, profileImages,email,phone,isPaidUser,isPaid,lookUpId ,is_ChatRequest,requestType,isBlurred ,isProfileImage,lagna,isPaidForAstrology,living_Preference_Id,living_Preference,themeColour
           ,themeColourText,themeColourNumber
    }
    ) {
        this.created_ForId = created_ForId;
        this.created_For = created_For;
        this.userid = userid;
        this.first_Name = first_Name;
        this.age = age;
        this.height = height;
        this.userNum = userNum;
        this.date_Of_Birth = date_Of_Birth;
        this.casteId = casteId;
        this.caste = caste;
        this.sub_Caste = sub_Caste;
        this.gothram = gothram;
        this.mother_TongueId = mother_TongueId;
        this.mother_Tongue = mother_Tongue;
        this.religionId = religionId;
        this.religion = religion;
        this.marital_StatusId = marital_StatusId;
        this.marital_Status = marital_Status;
        this.family_StatusId = family_StatusId;
        this.family_Status = family_Status;
        this.disability_id = disability_id;
        this.disability = disability;
        this.family_TypeId = family_TypeId;
        this.family_Type = family_Type;
        this.eating_HabitId = eating_HabitId;
        this.eating_Habit = eating_Habit;
        this.employed_InId = employed_InId;
        this.employed_In = employed_In;
        this.father_OccupationId = father_OccupationId;
        this.father_Occupation = father_Occupation;
        this.mother_OccupationId = mother_OccupationId;
        this.mother_Occupation = mother_Occupation;
        this.education_CategoryId = education_CategoryId;
        this.education_Category = education_Category;
        this.occupationId = occupationId;
        this.occupation = occupation;

        this.fromIncome_id = fromIncome_id;
        this.from_Income = from_Income;
        this.profileImage = profileImage;
        this.no_Of_Brothers = no_Of_Brothers;
        this.brothers_Married = brothers_Married;
        this.brothersMarried = brothersMarried;

        this.no_Of_Sister = no_Of_Sister;
        this.siters_Married = siters_Married;
        this.body_Type_id = body_Type_id;
        this.body_Type = body_Type;
        this.weight = weight;
        this.drinking_HabitId = drinking_HabitId;
        this.drinking_Habit = drinking_Habit;
        this.smoking_HabitId = smoking_HabitId;
        this.smoking_Habit = smoking_Habit;
        this.place_of_Birth = place_of_Birth;
        this.time_of_birth = time_of_birth;
        this.lives_In = lives_In;
        this.family_Values_Id = family_Values_Id;
        this.family_Values = family_Values;
        this.education_in_Detail = education_in_Detail;
        this.institution = institution;
        this.countryId = countryId;
        this.country = country;
        this.stateCode = stateCode;
        this.state_Id = state_Id;
        this.state = state;
        this.district_Id = district_Id;
        this.district = district;
        this.city = city;
        this.citizenship = citizenship;
        this.horoscope = horoscope;
        this.mobile_Number = mobile_Number;
        this.star = star;
        this.raasi = raasi;
        this.ancestral_Origin = ancestral_Origin;
        this.is_Shortlist = is_Shortlist;
        this.email_Status = email_Status;
        this.mobileNumber_Status = mobileNumber_Status;
        this.documentStatus = documentStatus;
        this.is_Interestlist = is_Interestlist;
        this.type = type;
        this.line_1 = line_1;
        this.line_2 = line_2;
        this.isBlocked = isBlocked;
        this.profileImages = profileImages || [];
        this.email = email;
        this.phone = phone;
        this.isPaidUser = isPaidUser;
        this.isPaid = isPaid;
        this.lookUpId = lookUpId;
        this.is_ChatRequest = is_ChatRequest;
        this.requestType = requestType;
        this.isBlurred = isBlurred;
        this.isProfileImage = isProfileImage;
        this.lagna = lagna;
        this.isPaidForAstrology = isPaidForAstrology;
        this.living_Preference_Id = living_Preference_Id;
        this.living_Preference = living_Preference;
        this.themeColour = themeColour;
        this.themeColourText = themeColourText;
        this.themeColourNumber = themeColourNumber;




    }
    static fromJson(json = {}) {
        return new ProfileDetailsRespone({
            created_ForId: json.created_ForId ?? 0,
            created_For: json.created_For ?? "",
            userid: json.userid ?? 0,
            first_Name: json.first_Name ?? "",
            age: json.age ?? 0,
            height: json.height ?? 0,
            userNum: json.userNum ?? "",
            date_Of_Birth: json.date_Of_Birth ?? "",
            casteId: json.casteId ?? 0,
            caste: json.caste ?? "",
            sub_Caste: json.sub_Caste ?? "",
            gothram: json.gothram ?? "",
            mother_TongueId: json.mother_TongueId ?? 0,
            mother_Tongue: json.mother_Tongue ?? "",
            religionId: json.religionId ?? 0,
            religion: json.religion ?? "",
            marital_StatusId: json.marital_StatusId ?? 0,
            marital_Status: json.marital_Status ?? "",
            family_StatusId: json.family_StatusId ?? 0,
            family_Status: json.family_Status ?? "",
            disability_id: json.disability_id ?? "",
            disability: json.disability ?? "",
            family_TypeId: json.family_TypeId ?? 0,
            family_Type: json.family_Type ?? "",
            eating_HabitId: json.eating_HabitId ?? 0,
            eating_Habit: json.eating_Habit ?? "",
            employed_InId: json.employed_InId ?? 0,
            employed_In: json.employed_In ?? "",
            father_OccupationId: json.father_OccupationId ?? 0,
            father_Occupation: json.father_Occupation ?? "",
            mother_OccupationId: json.mother_OccupationId ?? 0,
            mother_Occupation: json.mother_Occupation ?? "",
            education_CategoryId: json.education_CategoryId ?? 0,
            education_Category: json.education_Category ?? "",
            occupationId: json.occupationId ?? 0,
            occupation: json.occupation ?? "",
            fromIncome_id: json.fromIncome_id ?? "",
            from_Income: json.from_Income ?? 0,
            profileImage: json.profileImage ?? "",
            no_Of_Brothers: json.no_Of_Brothers ?? "",
            brothers_Married: json.brothers_Married ?? "",
            brothersMarried: json.brothersMarried ?? "",
            no_Of_Sister: json.no_Of_Sister ?? "",
            siters_Married: json.siters_Married ?? "",
            body_Type_id: json.body_Type_id ?? "",

            body_Type: json.body_Type ?? "",
            weight: json.weight ?? "",
            drinking_HabitId: json.drinking_HabitId ?? 0,
            drinking_Habit: json.drinking_Habit ?? "",
            smoking_HabitId: json.smoking_HabitId ?? 0,
            smoking_Habit: json.smoking_Habit ?? "",
            place_of_Birth: json.place_of_Birth ?? "",
            time_of_birth: json.time_of_birth ?? "",
            lives_In: json.lives_In ?? "",
            family_Values_Id: json.family_Values_Id ?? "",
            family_Values: json.family_Values ?? "",
            education_in_Detail: json.education_in_Detail ?? "",
            institution: json.institution ?? "",
            countryId: json.countryId ?? "",
            country: json.country ?? "",
            stateCode: json.stateCode ?? "",
            state_Id: json.state_Id ?? "",
            state: json.state ?? "",
            district_Id: json.district_Id ?? "",
            district: json.district ?? "",
            city: json.city ?? "",
            citizenship: json.citizenship ?? "",
            horoscope: json.horoscope ?? "",
            mobile_Number: json.mobile_Number ?? "",
            star: json.star ?? "",
            raasi: json.raasi ?? "",
            ancestral_Origin: json.ancestral_Origin ?? "",
            is_Shortlist: json.is_Shortlist ?? "",
            email_Status: json.email_Status ?? "",
            mobileNumber_Status: json.mobileNumber_Status ?? "",
            documentStatus: json.documentStatus ?? "",
            is_Interestlist: json.is_Interestlist ?? "",
            type: json.type ?? "",
            line_1: json.line_1 ?? "",
            line_2: json.line_2 ?? "",
            isBlocked: json.isBlocked ?? false,
            profileImages:json.profileImages??[],
            email: json.email ?? "",
            phone: json.phone ?? "",
            isPaidUser: json.isPaidUser ?? "",
            isPaid: json.isPaid ?? "",
            lookUpId: json.lookUpId ?? "",
            is_ChatRequest: json.is_ChatRequestlist ,
            requestType: json.requestType,
            isBlurred:json.isBlurred,
            isProfileImage:json.isProfileImage,
            lagna:json.lagna,
            isPaidForAstrology:json.isPaidForAstrology,
            living_Preference_Id:json.living_Preference_Id,
            living_Preference:json.living_Preference,
            themeColour:json.themeColour,
            themeColourText: json.themeColourText,
            themeColourNumber:json.themeColourNumber




        });
    }


}
export default ProfileDetailsRespone;